/* eslint-disable object-curly-newline */
/* eslint-disable no-multi-spaces */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSVLink, CSVDownload } from 'react-csv';

import { Switch, Route, Link } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faDownload, faWandMagicSparkles, faLink } from '@fortawesome/free-solid-svg-icons';
import { faSquareFacebook, faSquareTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { Modal, Box } from '@mui/material';
import injectSheet from 'react-jss';

import CreateBracketStyles from './CreateBracket_Styles';

import store from '../../redux/store';
import { setPicks } from '../../redux/features/picks/picksSlice';
import { getAllPicks, getAllCSVPicks, getNumOfPicks } from '../../redux/features/picks/picks';

import Groups from './Groups';
import Bracket from './Bracket';
import Drawer from './Drawer';
import MobileNav from './MobileNav';

const styles = CreateBracketStyles;

window.store = store;
store.subscribe(() => {
  localStorage.setItem('picks', JSON.stringify(store.getState().picks));
});

const csvHeaders = [
  { label: 'Round', key: 'round' },
  { label: 'Round Code', key: 'round_code' },
  { label: 'Home Team Code', key: 'home_team_code' },
  { label: 'Home Team', key: 'home_team' },
  { label: 'Away Team Code', key: 'away_team_code' },
  { label: 'Away Team', key: 'away_team' },
  { label: 'Winner Team', key: 'winner_team' },
];

const CreateBracket = ({
  classes,
  location,
  match,
  history,
  showIntro,
  handleShowIntro,
  showHow,
  handleShowHow,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const csvPicks = useSelector((state) => getAllCSVPicks(state));
  const pickz = useSelector((state) => getAllPicks(state));
  const numOfPicks = useSelector((state) => getNumOfPicks(state));

  const numOfGroupPicks = numOfPicks.a + numOfPicks.b + numOfPicks.c + numOfPicks.d + numOfPicks.e + numOfPicks.f + numOfPicks.g + numOfPicks.h;

  const dispatch = useDispatch();

  const csvBracketData = [
    { round: 'Group A1', round_code: 'A1', winner_team: csvPicks.A1.teamId },
    { round: 'Group A2',  round_code: 'A2', winner_team: csvPicks.A2.teamId },
    { round: 'Group B1',  round_code: 'B1', winner_team: csvPicks.B1.teamId },
    { round: 'Group B2',  round_code: 'B2', winner_team: csvPicks.B2.teamId },
    { round: 'Group C1',  round_code: 'C1', winner_team: csvPicks.C1.teamId },
    { round: 'Group C2',  round_code: 'C2', winner_team: csvPicks.C2.teamId },
    { round: 'Group D1',  round_code: 'D1', winner_team: csvPicks.D1.teamId },
    { round: 'Group D2',  round_code: 'D2', winner_team: csvPicks.D2.teamId },
    { round: 'Group E1',  round_code: 'E1', winner_team: csvPicks.E1.teamId },
    { round: 'Group E2',  round_code: 'E2', winner_team: csvPicks.E2.teamId },
    { round: 'Group F1',  round_code: 'F1', winner_team: csvPicks.F1.teamId },
    { round: 'Group F2',  round_code: 'F2', winner_team: csvPicks.F2.teamId },
    { round: 'Group G1',  round_code: 'G1', winner_team: csvPicks.G1.teamId },
    { round: 'Group G2',  round_code: 'G2', winner_team: csvPicks.G2.teamId },
    { round: 'Group H1',  round_code: 'H1', winner_team: csvPicks.H1.teamId },
    { round: 'Group H2',  round_code: 'H2', winner_team: csvPicks.H2.teamId },
    { round: 'Round of 16',  round_code: 'R49', home_team_code: 'A1', home_team: csvPicks.A1.teamId, away_team_code: 'B2', away_team: csvPicks.B2.teamId, winner_team: csvPicks.W49.teamId },
    { round: 'Round of 16',  round_code: 'R50', home_team_code: 'C1', home_team: csvPicks.C1.teamId, away_team_code: 'D2', away_team: csvPicks.D2.teamId, winner_team: csvPicks.W50.teamId },
    { round: 'Round of 16',  round_code: 'R51', home_team_code: 'B1', home_team: csvPicks.B1.teamId, away_team_code: 'A2', away_team: csvPicks.A2.teamId, winner_team: csvPicks.W51.teamId },
    { round: 'Round of 16',  round_code: 'R52', home_team_code: 'D1', home_team: csvPicks.D1.teamId, away_team_code: 'C2', away_team: csvPicks.C2.teamId, winner_team: csvPicks.W52.teamId },
    { round: 'Round of 16',  round_code: 'R53', home_team_code: 'E1', home_team: csvPicks.E1.teamId, away_team_code: 'F2', away_team: csvPicks.F2.teamId, winner_team: csvPicks.W53.teamId },
    { round: 'Round of 16',  round_code: 'R54', home_team_code: 'G1', home_team: csvPicks.G1.teamId, away_team_code: 'H2', away_team: csvPicks.H2.teamId, winner_team: csvPicks.W54.teamId },
    { round: 'Round of 16',  round_code: 'R55', home_team_code: 'F1', home_team: csvPicks.F1.teamId, away_team_code: 'E2', away_team: csvPicks.E2.teamId, winner_team: csvPicks.W55.teamId },
    { round: 'Round of 16',  round_code: 'R56', home_team_code: 'H1', home_team: csvPicks.H1.teamId, away_team_code: 'F2', away_team: csvPicks.F2.teamId, winner_team: csvPicks.W56.teamId },
    { round: 'Quarter Finals',  round_code: 'R57', home_team_code: 'W49', home_team: csvPicks.W49.teamId, away_team_code: 'W50', away_team: csvPicks.W50.teamId, winner_team: csvPicks.W57.teamId },
    { round: 'Quarter Finals',  round_code: 'R58', home_team_code: 'W53', home_team: csvPicks.W53.teamId, away_team_code: 'W54', away_team: csvPicks.W54.teamId, winner_team: csvPicks.W58.teamId },
    { round: 'Quarter Finals',  round_code: 'R59', home_team_code: 'W51', home_team: csvPicks.W51.teamId, away_team_code: 'W52', away_team: csvPicks.W52.teamId, winner_team: csvPicks.W59.teamId },
    { round: 'Quarter Finals',  round_code: 'R60', home_team_code: 'W55', home_team: csvPicks.W55.teamId, away_team_code: 'W56', away_team: csvPicks.W56.teamId, winner_team: csvPicks.W60.teamId },
    { round: 'Semi Finals',  round_code: 'R61', home_team_code: 'W57', home_team: csvPicks.W57.teamId, away_team_code: 'W58', away_team: csvPicks.W58.teamId, winner_team: csvPicks.W61.teamId },
    { round: 'Semi Finals',  round_code: 'R62', home_team_code: 'W59', home_team: csvPicks.W59.teamId, away_team_code: 'W60', away_team: csvPicks.W60.teamId, winner_team: csvPicks.W62.teamId },
    { round: 'Finals 3rd Place',  round_code: 'R63', home_team_code: 'L61', home_team: csvPicks.L61.teamId, away_team_code: 'L62', away_team: csvPicks.L62.teamId, winner_team: csvPicks.W63.teamId },
    { round: 'Finals',  round_code: 'R64', home_team_code: 'W61', home_team: csvPicks.W61.teamId, away_team_code: 'W62', away_team: csvPicks.W62.teamId, winner_team: csvPicks.W64.teamId },
  ];

  const pickForMe = () => {
    const teams = Object.values(store.getState().teams);
    const groups = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    const randomChance = () => ((Math.random() * 0.2) - 0.15);
    groups.forEach((group) => {
      const first = teams
        .filter((team) => team.group === group)
        .reduce((a, b) => ((Number(a.endfirst) || 0) + randomChance() > (Number(b.endfirst) || 0) + randomChance() ? a : b)); // eslint-disable-line max-len
      const second = teams
        .filter((team) => team.group === group && team.id !== first.id)
        .reduce((a, b) => ((Number(a.endfirst) || 0) + (Number(a.endsecond) || 0) + randomChance() > (Number(b.endfirst) || 0) + (Number(b.endsecond) || 0) + randomChance() ? a : b)); // eslint-disable-line max-len
      const picks = [{ id: `${group}1`, teamId: first.id }, { id: `${group}2`, teamId: second.id }];
      dispatch(setPicks(picks));
    });
  };

  const startOver = () => {
    const groups = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    groups.forEach((group) => {
      const picks = [{ id: `${group}1`, teamId: null }, { id: `${group}2`, teamId: null }];
      dispatch(setPicks(picks));
    });
  };

  // https://localhost:8080/#/?A1=QAT,A2=ECU,B1=USA,B2=WAL
  useEffect(() => {
    const params = location.search.slice(1).split(',');
    if (!params[0]) return;
    const picks = params.map((param) => ({ id: param.split('=')[0], teamId: param.split('=')[1] === 'null' ? null : param.split('=')[1] }));
    dispatch(setPicks(picks));
  }, []);

  const handleCopy = () => {
    const url = `${window.location.href.split('#')[0]}#/?${Object.values(pickz).reduce((string, pick) => `${string}${pick.id}=${pick.teamId},`, '')}`;
    const el = document.createElement('input');
    el.setAttribute('type', 'text');
    el.setAttribute('value', url);
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    el.remove();
    alert('copied to clipboard'); // eslint-disable-line no-alert
  };

  const handleShare = async (platform) => {
    const tab = window.open('about:blank');
    const url = `${window.location.href.split('#')[0]}#/?${Object.values(pickz).reduce((string, pick) => `${string}${pick.id}=${pick.teamId},`, '')}`;
    const res = await fetch(`https://api-ssl.bitly.com/v3/shorten?access_token=7ef8fe7360e7ca2f25c6d65fcc7e4bf7f11038ff&longUrl=${encodeURIComponent(url)}`);
    const resJSON = await res.json();
    const shareUrl = resJSON.data.url;

    if (platform === 'facebook') {
      tab.location.href = `http://www.facebook.com/share.php?u=${shareUrl}`;
    } else if (platform === 'twitter') {
      tab.location.href = `https://twitter.com/intent/tweet?text=Check+out+my+Qlik+2022+World+Cup+Bracket&url=${shareUrl}&hashtags=Qlik,WC2022`;
    } else if (platform === 'linkedin') {
      tab.location.href = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=Check%20out%20my%202022%20World%20Cup%20Bracket&summary=Check%20out%20my%20World%20Cup%20bracket%20in%20Qlik’s%20Choose%20Your%20Champion%202022%20app&source=Qlik%20Choose%20Your%20Champion`;
    }
  };

  // Mobile
  const handleDrawerOpen = () => {
    setTimeout(() => {
      setIsDrawerOpen(true);
    }, 50);
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  // Modal Functions
  const handleClose = () => {
    handleShowIntro();
  };

  const handleOpen = () => {
    handleShowIntro();
    handleShowHow();
  };

  return (
    <div className={classes.container}>

      {/* NAVBAR */}
      {window.innerWidth >= 600 && (
        <div className={classes.navbar}>
          <div className={classes.nav_title}>
            CHOOSE YOUR CHAMPION
          </div>
          <div className={classes.nav_text}>
            <div className={classes.nav_anchorselected}>Create a Bracket</div>
            <div className={classes.nav_anchor}><Link to="/historical-analysis/">Historical Analysis</Link></div>
          </div>
          <div className={classes.qliklogo}>
            <a href="https://www.qlik.com">
              <img className={classes.qlik} src="assets/images/qlik.png" alt="Qlik" />
            </a>
          </div>
        </div>
      )}

      {/* MOBILE NAV */}
      {window.innerWidth < 600 && (
        <div className={classes.navbar}>
          <div className={classes.nav_text}>
            <div className={classes.nav_title_mob}>
              CHOOSE YOUR CHAMPION
            </div>
          </div>
          <div className={classes.hamburger} onClick={() => handleDrawerOpen()}>
            <div className={classes.hamb} />
            <div className={classes.hamb} />
            <div className={classes.hamb} />
          </div>
          <Drawer isOpen={isDrawerOpen} handleClose={() => handleDrawerClose()} />
        </div>
      )}

      {/* GROUP STAGE SECTION */}
      <div style={{ display: window.innerWidth >= 600 || match.params.stage === 'groups' ? 'block' : 'none' }}>

        {/* Desktop */}
        {window.innerWidth >= 600 && (
          <div className={classes.groupstage}>
            <div className={classes.summary}>
              <div className={classes.summary_left}>
                <div className={classes.titleclick}>
                  GROUP STAGE
                </div>
                <div className={classes.intro}>
                  <div className={classes.text}>
                    <span> Select two countries from each group to advance to the next round. </span>
                  </div>
                </div>
              </div>
              <div className={classes.buttons}>
                <div className={classes.autocomplete} onClick={() => pickForMe()}>
                  <div className={classes.autocomplete_icon}>
                    <FontAwesomeIcon icon={faWandMagicSparkles} />
                  </div>
                  <div className={classes.autocomplete_text}>
                    AUTOCOMPLETE
                    <div className={classes.smalltext}> GROUP STAGE</div>
                  </div>
                </div>
                <div className={classes.startover} onClick={() => startOver()}>
                  <div className={classes.startover_icon}>
                    <FontAwesomeIcon icon={faTrashCan} />
                  </div>
                  <div className={classes.startover_text}>
                    START OVER
                    <div className={classes.smalltext} />
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.legend}>
              <div className={classes.legend_icon_first} />
              <div className={classes.legend_text}> First Group Choice </div>
              <div className={classes.legend_icon_second} />
              <div className={classes.legend_text}> Second Group Choice </div>
            </div>

            <Groups />

          </div>
        )}

        {/* mobile */}
        {window.innerWidth < 600 && (
        <div style={{ background: window.innerWidth < 600 ? '#e5e5e5' : '#fff' }}>
          <div className={classes.introm}>
            <div className={classes.roundname}>
              GROUP STAGE
              {numOfGroupPicks === 16 && <Link className={classes.next} to="/ko/eighths">Next</Link>}
            </div>
            <div className={classes.descm}>
              Scroll across the groups. Pick two teams in each group to advance to the next stage.
            </div>
          </div>
          <Groups />
        </div>
        )}

      </div>

      {/* BRACKET SECTION */}
      <div className={classes.bracket}>
        <Switch>
          <Route
            exact
            path="/ko/eighths"
            render={() => window.innerWidth < 600 && (
              <div>
                <div className={classes.roundname}>
                  ROUND OF SIXTEEN
                  {numOfPicks.eighths === 8 && <Link className={classes.next} to="/ko/quarters">Next</Link>}
                </div>
                <div className={classes.descm}>
                  {'It\'s Knockout stage. Pick your favorite teams to advance to the next round.'}
                </div>
              </div>
            )}
          />
          <Route
            exact
            path="/ko/quarters"
            render={() => window.innerWidth < 600 && (
              <div>
                <div className={classes.roundname}>
                  QUARTER-FINALS
                  {numOfPicks.quarters === 4 && <Link className={classes.next} to="/ko/semis">Next</Link>}
                </div>
                <div className={classes.descm}>
                  Only eight teams made it this far. Which four teams will you pick to continue?
                </div>
              </div>
            )}
          />
          <Route
            exact
            path="/ko/semis"
            render={() => window.innerWidth < 600 && (
              <div>
                <div className={classes.roundname}>
                  SEMI-FINALS
                  {numOfPicks.semis === 2 && <Link className={classes.next} to="/ko/thirdplace">Next</Link>}
                </div>
                <div className={classes.descm}>
                  Two exciting games. Choose two teams to play the final game.
                </div>
              </div>
            )}
          />
          <Route
            exact
            path="/ko/thirdplace"
            render={() => window.innerWidth < 600 && (
              <div>
                <div className={classes.roundname}>
                  THIRD PLACE
                  {numOfPicks.thirdplace === 1 && <Link className={classes.next} to="/ko/final">Next</Link>}
                </div>
                <div className={classes.descm}>
                  What team would end in the third place?
                </div>
              </div>
            )}
          />
          <Route
            exact
            path="/ko/final"
            render={() => window.innerWidth < 600 && (
              <div>
                <div className={classes.roundname}>
                  FINAL GAME
                </div>
                <div className={classes.descm}>
                  {'Is the final game! Pick the winner and don\'t forget to share your bracket.' }
                </div>
              </div>
            )}
          />
        </Switch>
        <Bracket match={match} />
      </div>

      {/* Footer */}
      {window.innerWidth >= 600 && (
        <div className={classes.footerBracket}>
          <div className={classes.footerBracketContent}>

            <div className={classes.linksFooter}>
              <span>Share:</span>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('facebook')} id="fb">
                  <FontAwesomeIcon icon={faSquareFacebook} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('twitter')} id="tw">
                  <FontAwesomeIcon icon={faSquareTwitter} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('linkedin')} id="li">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleCopy()}>
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </div>
            </div>

            <CSVLink data={csvBracketData} headers={csvHeaders} filename={`bracket_ ${Date.now()}.csv`} target="_blank">
              <FontAwesomeIcon icon={faDownload} />
              {' '}
              Download(.csv)
            </CSVLink>
          </div>
        </div>
      )}

      {window.innerWidth < 600 && <MobileNav history={history} match={match} />}
      {numOfPicks.final === 1 && (
        <div className={classes.footerBracket}>
          <div className={classes.footerBracketContent}>

            <div className={classes.linksFooter}>
              <span>Share:</span>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('facebook')} id="fb">
                  <FontAwesomeIcon icon={faSquareFacebook} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('twitter')} id="tw">
                  <FontAwesomeIcon icon={faSquareTwitter} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleShare('linkedin')} id="li">
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
              </div>
              <div className={classes.linkWithIcon}>
                <a onClick={() => handleCopy()}>
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </div>
            </div>

            <CSVLink data={csvBracketData} headers={csvHeaders} filename={`bracket_ ${Date.now()}.csv`} target="_blank">
              <FontAwesomeIcon icon={faDownload} />
              {' '}
              Download(.csv)
            </CSVLink>
          </div>
        </div>
      )}

      {/* WELCOME SCREENS */}

      <Modal
        open={showIntro}
        onClose={handleClose}
        aria-labelledby="Intro"
        aria-describedby="Intro"
        BackdropProps={{
          style: { backgroundColor: 'rgba(0,0,0,0.85)' },
        }}
      >
        <Box className={classes.modalContainer}>
          <div className={classes.dia}>
            <div className={classes.dia_intro}>
              <div className={classes.dia_introrow}>
                <img className={classes.dia_logo} src="assets/images/qatar2022-withlogo-alt.png" alt="logo" />
              </div>
              <div className={classes.dia_introrow2}>
                <img className={classes.dia_logo2} src="assets/images/choose-your-champion.png" alt="choose your champion" />
              </div>
              <div className={classes.dia_descrip}>
                <p>
                  {'The world\'s biggest tournament begins November 20th, 2022 in Qatar.'}
                </p>
              </div>
              <div className={classes.dia_buttons}>
                <div className={classes.dia_button} onClick={() => handleClose()}>
                  <span>CREATE YOUR BRACKET</span>
                </div>
                <div className={classes.dia_button}>
                  <Link to="/historical-analysis/">HISTORICAL ANALYSIS</Link>
                </div>
              </div>
              {
              window.innerWidth >= 600 && (
                <div
                  className={classes.howitworks}
                  onClick={() => handleOpen()}
                >
                  HOW IT WORKS?
                </div>
              )
             }
              <div className={classes.dia_credit}>
                <img className={classes.dia_crimg} src="assets/images/Powered-By-Qlik-Mark-Horizontal_RGB.png" alt="Powered By Qlik" />
              </div>
              <div className={classes.dia_legal}>
                © 1993-2022 QlikTech International AB, All Rights Reserved
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* HOW IT WORKS */}
      <Modal
        open={showHow}
        onClose={handleClose}
        aria-labelledby="Intro"
        aria-describedby="Intro"
        BackdropProps={{
          style: { backgroundColor: 'rgba(0,0,0,0.85)' },
        }}
      >
        <Box className={classes.modalContainer}>
          <div className={classes.dia} style={{ textAlign: 'left' }}>
            <div className={classes.hiw_dialog}>
              <div className={classes.hiw_content}>
                <div className={classes.dia_title}>HOW IT WORKS</div>
                <div className={classes.scrollarea}>
                  <div className={classes.dia_subtitle}>TOURNAMENT PROCESS</div>
                  <div className={classes.dia_desc}>
                    <p>
                      The tournament is structured in two stages.
                      The first stage is known as the
                      {' '}
                      <b>Group Stage</b>
                      {' '}
                      where the best two teams advance to the second stage,
                      the
                      {' '}
                      <b>Knockout Stage</b>
                      .The Knockout Stage has the teams playing single elimination games
                      until one team becomes the new champion.
                    </p>
                    <p>
                      During the Group Stage, the four teams within each group compete against each other with a winning team receiving three points and a draw (tie) awarding one point to each team.
                      <br />
                      The two teams with the most points in each group advance to the Knockout Stage.
                      <br />
                      The bottom two teams in each group are eliminated from the competition.
                    </p>
                  </div>
                  <div className={classes.cols}>
                    <div className={classes.col}>
                      <img className={classes.col_img} src="assets/images/hiw/1.png" alt="groups" />
                      <div className={classes.coltext}>
                        Scoring points for wins, each of the teams in the group play each other.
                        The top two teams advance, the other two are eliminated.
                      </div>
                    </div>
                    <div className={classes.col}>
                      <img className={classes.col_img} src="assets/images/hiw/2.png" alt="groups" />
                      <div className={classes.col_text_middle}>
                        Teams play single-elimination to advance their way to the championship game.
                      </div>
                    </div>
                    <div className={classes.col}>
                      <img className={classes.col_img} src="assets/images/hiw/3.png" alt="groups" />
                      <div className={classes.coltext}>
                        One country emerges victorious as the 2022 World Cup Champion.
                      </div>
                    </div>
                  </div>
                  <div className={classes.dia_subtitle}>FILLING UP A BRACKET</div>
                  <div className={classes.dia_desc}>
                    <p>
                      Begin in the Group Stage by selecting the top two teams from each group to advance to the Knockout Stage.
                      The bars for each team visualize the team&apos;s probability of advancing to the next stage.
                      The table in each group shows the probabilities for Wins, Draws, and Losses for each match-up between teams.
                      <b>To learn more about the teams in a group select the corresponding group info icon.</b>
                    </p>
                    <p style={{ textAlign: 'center', padding: '20px 0' }}>
                      <img src="assets/images/gif/groups.gif" alt="animation groups" />
                    </p>
                    <p>
                      When you reach the Knockout Stage simply select the circle of the team in each match-up you expect to win.
                      <b>Don&apos;t know who to select? Click on one of the team names to see stats on the head-to-head match.</b>
                    </p>
                    <p style={{ textAlign: 'center', padding: '20px 0' }}>
                      <img src="assets/images/gif/bracket.gif" alt="animation knockout" />
                    </p>
                  </div>
                  <div className={classes.dia_subtitle}>THE APP</div>
                  <div className={classes.dia_desc}>
                    <p>
                      For more information about Qlik and its product,
                      {' '}
                      <a href="https://www.qlik.com/us/products/qlik-sense" target="_blank" rel="noreferrer">click here</a>
                      {' '}
                      to get started embedding visualizations, creating visualization extensions, and integrating Qlik Sense into your web apps.
                    </p>
                  </div>
                </div>
                <div className={classes.dia_button} style={{ margin: '0 auto' }} onClick={() => handleClose()}>
                  <span>GET STARTED</span>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

    </div>
  );
};

CreateBracket.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  showIntro: PropTypes.bool.isRequired,
  handleShowIntro: PropTypes.func.isRequired,
  showHow: PropTypes.bool.isRequired,
  handleShowHow: PropTypes.func.isRequired,
};

export default injectSheet(styles)(CreateBracket);
